import { Div, Flex, Grid, Stack } from "@hopper-ui/components";
import type { PropsWithChildren } from "react";
import { ShareGateLogo } from "@sg-protect/components";
import { useShellTranslation } from "../i18n/i18next.ts";

export interface ErrorLayoutProps extends PropsWithChildren {
    variant?: "root" | "nested";
}

function RootErrorLayout({ children }: PropsWithChildren) {
    const { t } = useShellTranslation();

    return (
        <Grid backgroundColor="neutral" templateRows={["auto", "1fr"]} UNSAFE_height="100dvh" data-public>
            <Flex
                UNSAFE_minHeight={{
                    base: "150px",
                    md: "core_0"
                }}
                justifyContent={{
                    base: "center",
                    xs: "start"
                }}
                alignItems={{
                    base: "end",
                    xs: "start"
                }}
            >
                <ShareGateLogo
                    fill="neutral"
                    aria-label={t("ErrorLayout.logo")}
                    UNSAFE_width="13rem"
                    UNSAFE_height="5rem"
                />
            </Flex>
            <Flex justifyContent="center" alignItems="center">
                <Stack marginX="stack-md">{children}</Stack>
            </Flex>
        </Grid>
    );
}

function NestedErrorLayout({ children }: PropsWithChildren) {
    return (
        <Flex justifyContent="center" alignItems="center" UNSAFE_height="100dvh" width="100%" data-public>
            <Div marginX="stack-md">{children}</Div>
        </Flex>
    );
}

export function ErrorLayout({ variant = "root", children }: ErrorLayoutProps) {
    return variant === "root" ? (
        <RootErrorLayout>{children}</RootErrorLayout>
    ) : (
        <NestedErrorLayout>{children}</NestedErrorLayout>
    );
}
